import React, { useEffect, useMemo, useState } from "react";
import classes from "./Listing.module.css";
import { API_BASE_URL } from "configs/AppConfig";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import LoadingSpinner from "components/UI/loading-spinner/LoadingSpinner";
import WeddingPagination from "components/page-content/vendor-page/WeddingPagination";
import EventCard from "components/page-content/search-content/EventCard";

const ListingByCategoryAndLocation = () => {
    const defaultLimit = 2;
  const { category, location } = useParams();
  const [listings, setListings] = useState([]);

  const parseNumber = (value, fallback) => {
    const n = Number(value);
    return isNaN(n) || n <= 0 ? fallback : n;
  };
  const { search: qs } = useLocation();
   const query = useMemo(() => new URLSearchParams(qs), [qs]);
   const navigate = useNavigate();
 
   const [currentPage, setCurrentPage] = useState(
     parseNumber(query.get("page"), 1)
   );
   const [limit, setLimit] = useState(
     parseNumber(query.get("limit"), defaultLimit)
   )
  const [totalItems, setTotalItems] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState()


    const pushState = (overrides = {}) => {
      const params = new URLSearchParams();
  
      params.set("page", overrides.page ?? currentPage);
      params.set("limit", overrides.limit ?? limit);
  
      navigate({ search: `?${params.toString()}` }, { replace: true });
    };
  
    useEffect(() => {
      pushState();
    }, [
      currentPage,
      limit,
    ]);
  
    useEffect(() => {
      const fetchData = async () => {
        setListings([]);
        setLoading(true);
        setError(null);
        try {
          const endpoint = new URL(`${API_BASE_URL}listing/${category}/${location}`);
          endpoint.searchParams.set("page", currentPage);
          endpoint.searchParams.set("limit", limit);
  
          const res = await fetch(endpoint.toString());
          if (!res.ok) throw new Error("Failed to fetch data");
  
          const json = await res.json();
          setListings(json?.data ?? []);
          setTotalItems(json?.total ?? 0);
        } catch (err) {
          setError(err.message);
          setListings([]);
        } finally {
          setLoading(false);
          window.scrollTo({ top: 0, behavior: "smooth" });
        //   setClearLoading(false);
        }
      };
      fetchData();
    }, [qs]);



  const fetchListings = async () => {
    try{
        const response = await fetch(
      `${API_BASE_URL}listing/${category}/${location}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          // Authorization: `Bearer ${user.sessionToken}`,
        },
        // body: JSON.stringify(),
      }
    );

    const data = await response.json();
    setListings(data?.data);
    console.log("list by category response", data);
    if (!response.ok) {
      // message.error(data.message ? data.message : "Invalid Email or Password");
      throw new Error(data.message);
    }

    return data;

    }catch(err){

    }finally{

    }
    
  };

//   useEffect(() => {
//     fetchListings();
//   }, []);

   function createSlug(title) {
    return title
      .toLowerCase() // Convert to lowercase
      .trim() // Remove leading/trailing spaces
      .replace(/\s+/g, "-") // Replace spaces with hyphens
      .replace(/[^a-z0-9-]/g, "") // Remove special characters
      .replace(/--+/g, "-"); // Replace multiple hyphens with a single one
  }

  return (
    <div className={classes.outer}>
      <div className={classes.cardFlex}>
        {listings?.map((card) => (
          <div className={classes.eventCardWrapper}>
            <Link to={`/${createSlug(card.categoryName)}/${card.slug}`}>
              <EventCard
                listingId={card._id}
                image={card.images[0]}
                title={card?.name}
                review={card.review}
                city={card.location.locationName}
                state={card.state}
                price={card?.availableDates?.[0]?.intervals?.[0]?.price ?? ""}
                strikePrice={card.strikePrice}
                showPrice={card?.showPrice}
                categoryName={card?.categoryName}
                listingType={card?.listingType}
              />
            </Link>
          </div>
        ))}
      </div>
      {loading && listings?.length == 0 && (
        <div>
          <LoadingSpinner />
        </div>
      )}
      {error && listings?.length == 0 && (
        <h4 className={`${classes.errorText} home-error`}>No Data Found</h4>
      )}
      {!error && (
      <div className={classes.pagination}>
        <WeddingPagination
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          totalItemsCount={totalItems}
          itemsCountPerPage={limit}
        />
      </div>
      )}
    </div>
  );
};

export default ListingByCategoryAndLocation;
